import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { NetworkPointDetails } from 'src/pages/h2/network-points/details';
import { NetworkPointsOverview } from 'src/pages/h2/network-points/overview';

export const NetworkPoints: FC = () => {
  return (
    <RootRoutes>
      <Route path="/h2/network-points" element={<NetworkPointsOverview />} />
      <Route
        path="/h2/network-points/:networkPointOrBundleId"
        element={<NetworkPointDetails />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
